var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1442_127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 27.5C0 20.2065 2.89731 13.2118 8.05456 8.05456C13.2118 2.89731 20.2065 0 27.5 0C34.7935 0 41.7882 2.89731 46.9454 8.05456C52.1027 13.2118 55 20.2065 55 27.5C55 34.7935 52.1027 41.7882 46.9454 46.9454C41.7882 52.1027 34.7935 55 27.5 55C20.2065 55 13.2118 52.1027 8.05456 46.9454C2.89731 41.7882 0 34.7935 0 27.5Z",
    fill: "#FF7215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7886 26.2448V36.5353C38.7886 37.7902 37.7618 38.8169 36.5069 38.8169H18.2534C16.9984 38.8169 15.9717 37.7902 15.9717 36.5353V22.8451C15.9717 21.5902 16.9984 20.5634 18.2534 20.5634H29.7759C29.7075 20.9285 29.6618 21.3164 29.6618 21.7043C29.6618 23.3927 30.4034 24.8872 31.567 25.9368L27.3801 28.5493L18.2534 22.8451V25.1268L27.3801 30.831L33.4266 27.0434C34.0427 27.2716 34.6815 27.4085 35.366 27.4085C36.6552 27.4085 37.8303 26.9636 38.7886 26.2448ZM31.9435 21.7043C31.9435 23.5981 33.4722 25.1268 35.366 25.1268C37.2598 25.1268 38.7886 23.5981 38.7886 21.7043C38.7886 19.8105 37.2598 18.2817 35.366 18.2817C33.4722 18.2817 31.9435 19.8105 31.9435 21.7043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1442_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.8e2d53154ee0c741eec10eedde3d4e30.svg";
export { ForwardRef as ReactComponent };